import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { TrendingUp } from "react-feather";

function AccountingInvoices() {
  // Demo data
  const quotation = {
    totalAmount: 190000,
    unpaid: 25000,
    paid: 165000
  };

  const commission = {
    totalAmount: 185000,
    unpaid: 23000,
    paid: 162000
  };

  const taxes = {
    totalNumber: 50,
    totalCompliance: 45,
    totalNoncompliance: 5
  };

  return (
    <div className="card shadow p-4">
      <div className="mb-4">
        <h4 className="mb-1">This Shows Your Invoice Summaries</h4>
        <p className="text-muted mb-4">Overview of Quotation, Commission, and Taxes</p>

        {/* Quotation Section */}
        <div className="mb-4">
          <div className="d-flex align-items-center">
            <h5 className="mb-1 me-2">Quotation (Invoices sent to you for Quotation Payment)</h5>
          </div>
          <Row className="mb-4">
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-primary me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Amount</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {quotation.totalAmount.toLocaleString()}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-info me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Unpaid</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {quotation.unpaid.toLocaleString()}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-success me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Paid</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {quotation.paid.toLocaleString()}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Commission Section */}
        <div className="mb-4">
          <div className="d-flex align-items-center">
            <h5 className="mb-1 me-2">Commission (Invoices raised to your underwriter by the system on your Behalf)</h5>
          </div>
          <Row className="mb-4">
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-primary me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Amount</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {commission.totalAmount.toLocaleString()}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-info me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Unpaid</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {commission.unpaid.toLocaleString()}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-success me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Paid</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {commission.paid.toLocaleString()}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Taxes Section */}
        <div>
          <div className="d-flex align-items-center">
            <h5 className="mb-1 me-2">Taxes (Invoices Created that are Compliant to ETIMs)</h5>
          </div>
          <Row className="mb-4">
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-primary me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Number</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      {taxes.totalNumber}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-info me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Compliance</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      {taxes.totalCompliance}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
                <Card.Body className="d-flex align-items-center">
                  <TrendingUp size={40} className="text-success me-3" />
                  <div>
                    <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Noncompliance</Card.Title>
                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      {taxes.totalNoncompliance}
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default AccountingInvoices;